import React, { PureComponent } from 'react';
import { some, reject } from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SectionTitle from '@src/components/SectionTitle';
import apolloClient from '@src/graphql/apollo';
import { SenioritiesQueryDocument, SenioritiesQueryQuery } from '@src/graphql/generated';
import './styles.scss';

export default class Seniorities extends PureComponent {
  static propTypes = {
    activeSeniorities: PropTypes.arrayOf(PropTypes.object),
    setSeniorities: PropTypes.func.isRequired,
  };

  _isMounted = false;

  state = {
    selectedSeniorities: this.props.activeSeniorities,
    seniorities: undefined,
  };

  async componentDidMount() {
    this._isMounted = true;

    const {
      data: { seniorities },
    } = await apolloClient.query<SenioritiesQueryQuery>({
      fetchPolicy: 'no-cache',
      query: SenioritiesQueryDocument,
    });

    if (this._isMounted) {
      this.setState({ seniorities });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeSeniorities !== this.state.selectedSeniorities) {
      this.setState({ selectedSeniorities: nextProps.activeSeniorities });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setSeniorities = seniority => {
    this.setState(
      ({ selectedSeniorities }) => {
        const alreadySelected = some(selectedSeniorities, { id: seniority.id });

        if (alreadySelected) {
          return { selectedSeniorities: reject(selectedSeniorities, { id: seniority.id }) };
        }

        if (selectedSeniorities) {
          return {
            selectedSeniorities: [...selectedSeniorities, seniority],
          };
        }

        return { selectedSeniorities: [seniority] };
      },
      () => this.props.setSeniorities(this.state.selectedSeniorities),
    );
  };

  render() {
    const { selectedSeniorities, seniorities } = this.state;

    if (!seniorities) {
      return null;
    }

    return (
      <div className="create-funnel-seniorities">
        <SectionTitle subtitle="You can choose multiple" title="with following seniority" />

        <div className="grid-selection">
          {seniorities.map(seniority => {
            return (
              <button
                className={classnames(
                  'grid-selection-item',
                  some(selectedSeniorities, { id: seniority.id }) && 'selected',
                )}
                key={seniority.id}
                onClick={() => this.setSeniorities(seniority)}
              >
                <span>{seniority.name}</span>
              </button>
            );
          })}
        </div>
      </div>
    );
  }
}
